import { OptionItem } from './OptionItem';

export const FixedOptions = ({ fixes }: { fixes: Array<{ name: string; origin: string }> }) => {
    if (!fixes?.length) return null;
    return (
        <ul>
            {fixes.map((fix, index) => (
                <li key={`fixes-${index}`}>
                    <OptionItem name={fix.name} origin={fix.origin} />
                </li>
            ))}
        </ul>
    );
};
